const localization = {
  abwd: {
    en: {
      bw_alert_publisher: ' Low upload bandwidth',
      bw_alert_subscriber: ' Low Download bandwidth',
      video_muted: ' Video muted due to low bandwidth',
    },
    zh: {
      bw_alert_publisher: ' 网络不好',
      bw_alert_subscriber: '你的下载带宽很低',
      video_muted: ' 您的视频因带宽而静音',
    },
  },
};

export default localization;



//////////////////
// WEBPACK FOOTER
// ./src/Localization.js
// module id = 163
// module chunks = 0